import {
  FlightChargeTypeEnum,
  FlightRateTypeEnum,
  IFlightRate,
  IFlightRateCharge,
} from '@cai-services';

export class FlightRate implements IFlightRate {
  id?: string;
  rateId?: number;
  name: string;
  type: FlightRateTypeEnum;
  currency: string;
  netRate: number;
  isManualRate?: boolean;
  isSpotQuoteRate?: boolean;
  allInRate: number;
  total: number;
  minimumRate: boolean;
  charges: Charge[];
  ocdc: Charge[];
  formattedName?: string;
  lastUpdatedDate: any;
  latestAcceptanceTime?: string;
  timeOfAvailability?: string;
  handlingCodes?: string[];
  coloaderOfficeId?: number;
  allotmentCode?: string;
  day?: string;
  density?: string;
  aircraftTypes?: string[];
  airlineProdCode?: string;
  airlineRateRemarks?: string;
}

export class Charge implements IFlightRateCharge {
  code: string;
  label: string;
  type: FlightChargeTypeEnum;
  rate: number;
  minAmount?: number;
}
